import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

const MAX_TRACKED_IDS = 300

type State = {
  seenIds: number[]
  lastSeenAt: number | null
  initialized: boolean
  announcementsMuted: boolean
}

type Actions = {
  markSeen: (ids: number[]) => void
  initialize: (ids: number[]) => void
  setAnnouncementsMuted: (muted: boolean) => void
}

const mergeIds = (current: number[], incoming: number[]): number[] => {
  const merged = Array.from(new Set([...incoming, ...current]))
  return merged.slice(0, MAX_TRACKED_IDS)
}

export const useNewsSeenStore = create<State & Actions>()(
  devtools(
    persist(
      zustandPlugin(
        (set) => ({
          seenIds: [],
          lastSeenAt: null,
          initialized: false,
          announcementsMuted: false,
          markSeen: (ids) =>
            set(
              (s) => ({
                seenIds: mergeIds(s.seenIds, ids),
                lastSeenAt: Date.now(),
                initialized: true,
              }),
              false,
              'markSeen',
            ),
          initialize: (ids) =>
            set(
              (s) =>
                s.initialized
                  ? {}
                  : { seenIds: mergeIds(s.seenIds, ids), initialized: true },
              false,
              'initialize',
            ),
          setAnnouncementsMuted: (muted) =>
            set({ announcementsMuted: muted }, false, 'setAnnouncementsMuted'),
        }),
        'news-seen',
      ),
      {
        name: 'news-seen',
        storage: createJSONStorage(() => localStorage),
        partialize: (s) => ({
          seenIds: s.seenIds,
          lastSeenAt: s.lastSeenAt,
          initialized: s.initialized,
          announcementsMuted: s.announcementsMuted,
        }),
      },
    ),
    { name: 'EasyTacho', store: 'news-seen' },
  ),
)
